import { AddressField as FieldDefinition } from '@bybeam/platform-types';
import GenericAddressField from '@platform-ui-common/components/GenericAddressField/index.js';
import useApplication from '@platform-ui-common/hooks/contexts/useApplication.js';
import {
  Action,
  GenericFormData,
  fieldUpdate,
  optionalField,
} from '@platform-ui-common/hooks/useForm/index.js';
import { resetAddress } from '@platform-ui-common/utilities/address.js';
import {
  getFieldAnswersValue,
  getUnhousedField,
} from '@platform-ui/utilities/application/fields/index.js';
import { Dispatch } from 'react';
import CheckboxField from '../CheckboxField.js';
import { FieldProps } from '../types.js';

export default function AddressField<FormData extends GenericFormData>({
  field: { key, filter, allowUnhoused, copyAddressKey, copy },
  validation,
  setValidationOverrides: _,
  ...props
}: FieldProps<FieldDefinition, FormData>): JSX.Element {
  const { answers: formData, dispatch, showManualAddressButton, showManualInput, errors } = props;
  const { answers, addresses } = useApplication();

  const copyTargetAddress = addresses?.find(
    (addressItem) => addressItem.id === getFieldAnswersValue(`${copyAddressKey}Id`, answers),
  );

  const handleCopyAddress = (value: boolean): void => {
    dispatch(fieldUpdate(`${key}.copied`, value as FormData[typeof key]));
    resetAddress(dispatch, key, value ? copyTargetAddress : undefined);
  };

  const field = {
    copyAddressKey,
    filter,
    key,
    copy,
    validation: { required: validation.required },
  };
  return (
    <>
      {allowUnhoused && (
        <CheckboxField
          field={getUnhousedField(key)}
          validation={optionalField<FormData>()}
          {...props}
        />
      )}
      <GenericAddressField
        field={field}
        answers={formData}
        showManualAddressButton={showManualAddressButton}
        showManualInput={showManualInput}
        errors={errors}
        handleCopyAddress={handleCopyAddress}
        dispatch={dispatch as undefined as Dispatch<Action<GenericFormData>>}
      />
    </>
  );
}
